var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.styles.card, _vm.active ? _vm.styles.active : '', _vm.replace ? _vm.styles.replace : '']},[(_vm.$slots.title?.length > 0)?_c('div',{staticClass:"fw-500 fs-16",class:_vm.styles.title},[_vm._t("title")],2):_vm._e(),_vm._t("default"),(_vm.$slots.buttons?.length > 0)?_c('Buttons',[_vm._t("buttons")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }